import { render } from "./PageListarVinculoDepartamentoMedico.vue?vue&type=template&id=12c9b197"
import script from "./PageListarVinculoDepartamentoMedico.vue?vue&type=script&lang=js"
export * from "./PageListarVinculoDepartamentoMedico.vue?vue&type=script&lang=js"

import "./PageListarVinculoDepartamentoMedico.vue?vue&type=style&index=0&id=12c9b197&lang=css"
/* custom blocks */
import block0 from "./PageListarVinculoDepartamentoMedico.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__